
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/introduction",
      function () {
        return require("private-next-pages/about/introduction/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/introduction"])
      });
    }
  